import {
  IonButton,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
} from '@ionic/angular/standalone';

import { Component, OnInit, input, output, inject } from '@angular/core';
import { eGain } from 'src/app/util/eGain';
import { TooltipProvider } from '@countryfinancial-arlo/ionic';
import { addIcons } from 'ionicons';
import { openOutline } from 'ionicons/icons';
import { Router } from '@angular/router';
import { HttpHelperService } from 'src/app/services/http-helper/http-helper.service';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'template-help-menu',
  templateUrl: './help-menu.component.html',
  styleUrls: ['./help-menu.component.scss'],
  imports: [IonButton, IonIcon, IonItem, IonLabel, IonList, IonListHeader],
})
export class HelpMenuComponent implements OnInit {
  private egain = inject(eGain);
  private router = inject(Router);
  tooltipProvider = inject(TooltipProvider);
  httpHelper = inject(HttpHelperService);

  readonly isLoggedIn = input<boolean>();
  closeMenu = output<void>();

  isNative: boolean = false;
  constructor() {
    addIcons({ openOutline });
    if (Capacitor.isNativePlatform()) {
      this.isNative = true;
    }
  }

  openOnlineChat() {
    this.egain.clickToChat();
  }

  scheduleCallback() {
    // trigger schedule a call back functionality
  }

  ngOnInit() {}

  async navigateToAssistedRegistration() {
    // TODO: The 'emit' function requires a mandatory void argument
    this.closeMenu.emit();
    const url = 'registration/assisted-registration';
    await this.router.navigateByUrl(url);
  }
}
